import { ChangeDetectorRef, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import Swal from 'sweetalert2';
import { RefreshToken } from '../../models/refreshToken.model';
import { DOCUMENT } from '@angular/common';
import {MsalService} from "@azure/msal-angular";

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit {

  titulo = 'Módulo administrador de roles';
  objeto!: RefreshToken;
  activeContrast: any = false;
  constructor(private loginService: LoginService,

              private msalService: MsalService,
              private router: Router,  @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,  private cdRef: ChangeDetectorRef)
  { }

  moveContrast() {

    const footerElement = this.document.querySelector('footer');
    const headerElement = this.document.querySelector('header');
    const cardElement = this.document.querySelector('.card');
    const cardHeader = this.document.querySelectorAll('.card-header');
    const cardButton = this.document.querySelector('.btn');
    const socialBar = this.document.querySelector('.social-bar');
    const jumbo = this.document.querySelector('.general');
    const title = this.document.querySelector('.title');

    let listavalores:any[] =[];
    listavalores.push(cardHeader)

    if (!this.activeContrast) {
      this.DeActiveContrast(footerElement,headerElement,cardElement,cardButton,cardHeader,socialBar,jumbo,
        title,listavalores);


    } else {
      this.ActiveContrast(footerElement,headerElement,cardElement,cardButton,cardHeader,socialBar,jumbo,
        title);
    }
  }

  ActiveContrast(footerElement:any,headerElement:any,cardElement:any,cardButton:any,cardHeader:any,socialBar:any,jumbo:any,
  title:any)
  {
    this.renderer.setStyle(this.document.body, 'background-color', 'black');

    if (footerElement) {
      this.renderer.setStyle(footerElement, 'background-color', 'black');
      this.renderer.setStyle(footerElement, 'border-top', '3px solid yellow');
    }
    if (headerElement) {
      this.renderer.setStyle(headerElement, 'background-color', 'black');
      this.renderer.setStyle(headerElement, 'border-bottom', '3px solid yellow');
    }
    if(cardElement){
      this.renderer.setStyle(cardElement, 'border', '1px solid #DDDEDF');
      this.renderer.setStyle(cardElement, 'background-color', '#fff');
      this.renderer.setStyle(cardElement, 'color', '#3498DB');
    }

    if(cardHeader){
      this.renderer.setStyle(cardHeader, 'background-color', '#fff');
      this.renderer.setStyle(cardHeader, 'color', '#fff !important');
    }

    if(cardButton){
      this.renderer.setStyle(cardButton, 'border', '3px solid yellow');
      this.renderer.setStyle(cardButton, 'background-color', '#000');
      this.renderer.setStyle(cardButton, 'color', '#fff');
    }

    if(socialBar){
      this.renderer.setStyle(socialBar, 'background-color', '#0000');
      this.renderer.setStyle(socialBar, 'color', '#fff');
      this.renderer.setStyle(socialBar, 'border', '3px solid yellow');
    }

    if(jumbo){
      this.renderer.setStyle(jumbo, 'background-color', '#0000');
      this.renderer.setStyle(jumbo, 'color', '#fff !important');
      this.renderer.setStyle(jumbo, 'border', '3px solid yellow');
    }

    if(title){
      this.renderer.setStyle(title, 'color', '#fff');
    }
  }
  DeActiveContrast(footerElement:any,headerElement:any,cardElement:any,cardButton:any,cardHeader:any,socialBar:any,jumbo:any,
                   title:any,listavalores:any)
  {
    this.renderer.setStyle(this.document.body, 'background-color', 'white');
    if (footerElement) {
      this.renderer.setStyle(footerElement, 'background-color', '#40bce4');
      this.renderer.setStyle(footerElement, 'border-top', 'none');
    }
    if (headerElement) {
      this.renderer.setStyle(headerElement, 'background-color', '#40bce4');
      this.renderer.setStyle(headerElement, 'border-bottom', 'none');
    }
    if(cardElement){
      this.renderer.setStyle(cardElement, 'border', '1px solid #DDDEDF');
      //this.renderer.setStyle(cardElement, 'background-color', 'red');
      this.renderer.setStyle(cardElement, 'color', '#3498DB');
    }

    if(cardHeader){
      for (let elements of listavalores) {
        for (let element of elements) {
          element.style.backgroundColor = '#fff';
          element.style.color = '#266090';
        }
      }
    }


    if(cardButton){
      this.renderer.setStyle(cardButton, 'border', '3px solid #266090');
      this.renderer.setStyle(cardButton, 'background-color', '#266090');
      this.renderer.setStyle(cardButton, 'color', '#fff');
    }

    if(socialBar){
      this.renderer.setStyle(socialBar, 'background-color', '#266090');
      this.renderer.setStyle(socialBar, 'color', '#fff');
      this.renderer.setStyle(socialBar, 'border', '3px solid white');
    }

    if(jumbo){
      this.renderer.setStyle(jumbo, 'background-color', '#f0ecec');
      this.renderer.setStyle(jumbo, 'color', '#266090');
      this.renderer.setStyle(jumbo, 'border', 'none');
    }

    if(title){
      this.renderer.setStyle(title, 'color', '#266090');
    }

  }

  ngOnInit(): void {
    this.moveContrast();
  }


  salir(): void {
    Swal.fire({
      text: '¿Seguro que desea cerrar su sesión?',
      iconHtml: '<img src="assets/img/warning.png" class="w-75 ms-3">',
      customClass: {
        icon: 'no-bordes',
        htmlContainer: 'text-warning fw-bold'
      },
      allowOutsideClick: false,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    }).then(resp => {
      if (resp.value) {
        this.objeto = {
          tokenValue: localStorage.getItem('refreshToken')+"",
          userId: localStorage.getItem('userId')+"",
          dateIssued: this.loginService.traerFechaString(1),
          dateExpired: this.loginService.traerFechaString(1)
        }


        this.msalService.logoutPopup().subscribe(resp =>
        {
          localStorage.clear();
          this.router.navigateByUrl('login');
        });


      }
    });
  }
}
